<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form @submit="reset">
                  <h1>Recuperar senha</h1>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>@</b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="email" class="form-control" placeholder="E-mail" autocomplete="username email" v-model="email" />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" type="submit" :disabled="isLoading">Enviar</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <div class="card text-white py-5 d-md-down-none" style="width:44%">
              <div class="card-body text-center">
                <img src="/assets/img/logo.jpg" alt="" width="100%" style="padding-top:8%">
              </div>
            </div>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ResetPassword',
  data() {
    return {
      email: '',
      isLoading: false,
    }
  },
  methods: {
    reset(e) {
      if (!e.target.checkValidity()) {
        return;
      }

      e.preventDefault();
      this.isLoading = true;

      this.$store.dispatch('auth/reset', {
        email: this.email,
        success: () => {
          this.$swal.fire({
            title: 'Link enviado com sucesso.',
            text: 'Verifique sua caixa de e-mails.',
            type: 'success',
          });
        },
        error: () => {
          this.$swal.fire({
            title: 'Aviso',
            text: 'Houve um erro, tente novamente.',
            type: 'error',
          });
        }
      });
    }
  },
}

</script>
